import CompetencySearchSelect from './CompetencySearchSelect';
import React, { useMemo } from "react";
import DatePickerInput from "../common/DatePickerInput";
import SearchableSelect from "../common/SearchableSelect";
import {
  DIPLOMA_ANAESTHESIA_CATEGORIES,
  DIPLOMA_ANAESTHESIA_PROCEDURES,
  isDiplomaInAnaesthesiaDept,
} from "../../../constants/anaesthesiaProcedures";
import {
  CLINICAL_PATHOLOGY_CATEGORIES,
  CLINICAL_PATHOLOGY_PROCEDURES,
  isDiplomaInClinicalPathologyDept,
} from "../../../constants/clinicalPathologyProcedures";
import {
  DVL_CATEGORIES,
  DVL_PROCEDURES,
  isDiplomaInDVLDept,
} from "../../../constants/dvlProcedures";
import {
  ENT_CATEGORIES,
  ENT_PROCEDURES,
  isDiplomaInENTDept,
} from "../../../constants/entProcedures";
import {
  IMMUNOHAEMATOLOGY_CATEGORIES,
  IMMUNOHAEMATOLOGY_PROCEDURES,
  isDiplomaInImmunohaematologyDept,
} from "../../../constants/immunohaematologyProcedures";
import {
  OBGY_CATEGORIES,
  OBGY_PROCEDURES,
  isDiplomaInOBGYDept,
} from "../../../constants/obgyProcedures";
import {
  OPHTHALMOLOGY_CATEGORIES,
  OPHTHALMOLOGY_PROCEDURES,
  isDiplomaInOphthalmologyDept,
} from "../../../constants/ophthalmologyProcedures";
import {
  ORTHOPAEDICS_CATEGORIES,
  ORTHOPAEDICS_PROCEDURES,
  isDiplomaInOrthopaedicsDept,
} from "../../../constants/orthopaedicsProcedures";
import {
  PAEDIATRICS_CATEGORIES,
  PAEDIATRICS_PROCEDURES,
  isDiplomaInPaediatricsDept,
} from "../../../constants/paediatricsProcedures";
import {
  PSYCHIATRY_CATEGORIES,
  PSYCHIATRY_PROCEDURES,
  isDiplomaInPsychiatryDept,
} from "../../../constants/psychiatryProcedures";
import {
  PMR_CATEGORIES,
  PMR_PROCEDURES,
  isDiplomaInPMRDept,
} from "../../../constants/pmrProcedures";
import {
  PULMONARY_CATEGORIES,
  PULMONARY_PROCEDURES,
  isDiplomaInPulmonaryDept,
} from "../../../constants/pulmonaryProcedures";
import {
  RADIODIAGNOSIS_CATEGORIES,
  RADIODIAGNOSIS_PROCEDURES,
  isDiplomaInRadioDiagnosisDept,
} from "../../../constants/radiodiagnosisProcedures";
import {
  RADIATION_MEDICINE_CATEGORIES,
  RADIATION_MEDICINE_PROCEDURES,
  isDiplomaInRadiationMedicineDept,
} from "../../../constants/radiationMedicineProcedures";
import {
  TROPICAL_MEDICINE_CATEGORIES,
  TROPICAL_MEDICINE_PROCEDURES,
  isDiplomaInTropicalMedicineDept,
} from "../../../constants/tropicalMedicineProcedures";
import {
  ALLERGY_IMMUNOLOGY_CATEGORIES,
  ALLERGY_IMMUNOLOGY_PROCEDURES,
  isDiplomaInAllergyImmunologyDept,
} from "../../../constants/allergyImmunologyProcedures";
import {
  AEROSPACE_CATEGORIES,
  AEROSPACE_PROCEDURES,
  isMDInAerospaceDept,
} from "../../../constants/aerospaceProcedures";
import {
  ANATOMY_CATEGORIES,
  ANATOMY_PROCEDURES,
  isMDInAnatomyDept,
} from "../../../constants/anatomyProcedures";
import {
  BIOCHEMISTRY_CATEGORIES,
  BIOCHEMISTRY_PROCEDURES,
  isMDInBiochemistryDept,
} from "../../../constants/biochemistryProcedures";
import {
  COMMUNITY_MEDICINE_CATEGORIES,
  COMMUNITY_MEDICINE_PROCEDURES,
  isMDInCommunityMedicineDept,
} from "../../../constants/communityMedicineProcedures";
import {
  DVL_MD_CATEGORIES,
  DVL_MD_PROCEDURES,
  isMDInDVLDept,
} from "../../../constants/dvlMDProcedures";
import {
  FAMILY_MEDICINE_CATEGORIES,
  FAMILY_MEDICINE_PROCEDURES,
  isMDInFamilyMedicineDept,
} from "../../../constants/familyMedicineProcedures";
import {
  FORENSIC_MEDICINE_CATEGORIES,
  FORENSIC_MEDICINE_PROCEDURES,
  isMDInForensicMedicineDept,
} from "../../../constants/forensicMedicineProcedures";
import {
  GENERAL_MEDICINE_CATEGORIES,
  GENERAL_MEDICINE_PROCEDURES,
  isMDInGeneralMedicineDept,
} from "../../../constants/generalMedicineProcedures";
import {
  GERIATRICS_CATEGORIES,
  GERIATRICS_PROCEDURES,
  isMDInGeriatricsDept,
} from "../../../constants/geriatricsProcedures";
import {
  HEALTH_ADMIN_CATEGORIES,
  HEALTH_ADMIN_PROCEDURES,
  isMDInHealthAdminDept,
} from "../../../constants/healthAdminProcedures";
import {
  IMMUNOHEMATOLOGY_MD_CATEGORIES,
  IMMUNOHEMATOLOGY_MD_PROCEDURES,
  isMDInImmunohematologyDept,
} from "../../../constants/immunohematologyMDProcedures";
import {
  MICROBIOLOGY_CATEGORIES,
  MICROBIOLOGY_PROCEDURES,
  isMDInMicrobiologyDept,
} from "../../../constants/microbiologyProcedures";
import {
  NUCLEAR_MEDICINE_MD_CATEGORIES,
  NUCLEAR_MEDICINE_MD_PROCEDURES,
  isMDInNuclearMedicineDept,
} from "../../../constants/nuclearMedicineMDProcedures";
import {
  PATHOLOGY_MD_CATEGORIES,
  PATHOLOGY_MD_PROCEDURES,
  isMDInPathologyDept,
} from "../../../constants/pathologyMDProcedures";
import {
  PHARMACOLOGY_CATEGORIES,
  PHARMACOLOGY_PROCEDURES,
  isMDInPharmacologyDept,
} from "../../../constants/pharmacologyProcedures";
import {
  PHYSIOLOGY_CATEGORIES,
  PHYSIOLOGY_PROCEDURES,
  isMDInPhysiologyDept,
} from "../../../constants/physiologyProcedures";
import {
  RADIOTHERAPY_MD_CATEGORIES,
  RADIOTHERAPY_MD_PROCEDURES,
  isMDInRadiotherapyDept,
} from "../../../constants/radiotherapyMDProcedures";
import {
  SPORTS_MEDICINE_CATEGORIES,
  SPORTS_MEDICINE_PROCEDURES,
  isMDInSportsMedicineDept,
} from "../../../constants/sportsMedicineProcedures";
import {
  PALLIATIVE_MEDICINE_CATEGORIES,
  PALLIATIVE_MEDICINE_PROCEDURES,
  isMDInPalliativeMedicineDept,
} from "../../../constants/palliativeMedicineProcedures";
import {
  MARINE_MEDICINE_CATEGORIES,
  MARINE_MEDICINE_PROCEDURES,
  isMDInMarineMedicineDept,
} from "../../../constants/marineMedicineProcedures";
import {
  LABORATORY_MEDICINE_CATEGORIES,
  LABORATORY_MEDICINE_PROCEDURES,
  isMDInLaboratoryMedicineDept,
} from "../../../constants/laboratoryMedicineProcedures";
import {
  EMERGENCY_MEDICINE_CATEGORIES,
  EMERGENCY_MEDICINE_PROCEDURES,
  isMDInEmergencyMedicineDept,
} from "../../../constants/emergencyMedicineProcedures";
import {
  GENERAL_SURGERY_CATEGORIES,
  GENERAL_SURGERY_PROCEDURES,
  isMSInGeneralSurgeryDept,
} from "../../../constants/generalSurgeryProcedures";
import {
  TRAUMATOLOGY_CATEGORIES,
  TRAUMATOLOGY_PROCEDURES,
  isMSInTraumatologyDept,
} from "../../../constants/traumatologyProcedures";
import {
  CLINICAL_IMMUNOLOGY_CATEGORIES,
  CLINICAL_IMMUNOLOGY_PROCEDURES,
  isDMInClinicalImmunologyDept,
} from "../../../constants/clinicalImmunologyProcedures";
import {
  HEPATOLOGY_CATEGORIES,
  HEPATOLOGY_PROCEDURES,
  isDMInHepatologyDept,
} from "../../../constants/hepatologyProcedures";
import {
  CRITICAL_CARE_CATEGORIES,
  CRITICAL_CARE_PROCEDURES,
  isDMInCriticalCareDept,
} from "../../../constants/criticalCareProcedures";
import {
  NEUROANAESTHESIA_CATEGORIES,
  NEUROANAESTHESIA_PROCEDURES,
  isDMInNeuroanaesthesiaDept,
} from "../../../constants/neuroanaesthesiaProcedures";
import {
  NEURORADIOLOGY_CATEGORIES,
  NEURORADIOLOGY_PROCEDURES,
  isDMInNeuroradiologyDept,
} from "../../../constants/neuroradiologyProcedures";
import {
  ORGAN_TRANSPLANT_ANAESTHESIA_CATEGORIES,
  ORGAN_TRANSPLANT_ANAESTHESIA_PROCEDURES,
  isDMInOrganTransplantAnaesthesiaDept,
} from "../../../constants/organTransplantAnaesthesiaProcedures";
import {
  PEDIATRIC_ONCOLOGY_CATEGORIES,
  PEDIATRIC_ONCOLOGY_PROCEDURES,
  isDMInPediatricOncologyDept,
} from "../../../constants/pediatricOncologyProcedures";
import {
  PEDIATRIC_HEPATOLOGY_CATEGORIES,
  PEDIATRIC_HEPATOLOGY_PROCEDURES,
  isDMInPediatricHepatologyDept,
} from "../../../constants/pediatricHepatologyProcedures";
import {
  PAEDIATRIC_NEUROLOGY_CATEGORIES,
  PAEDIATRIC_NEUROLOGY_PROCEDURES,
  isDMInPaediatricNeurologyDept,
} from "../../../constants/paediatricNeurologyProcedures";
import {
  VIROLOGY_CATEGORIES,
  VIROLOGY_PROCEDURES,
  isDMInVirologyDept,
} from "../../../constants/virologyProcedures";
import {
  INFECTIOUS_DISEASES_CATEGORIES,
  INFECTIOUS_DISEASES_PROCEDURES,
  isDMInInfectiousDiseasesDept,
} from "../../../constants/infectiousDiseasesProcedures";
import {
  ENDOCRINOLOGY_CATEGORIES,
  ENDOCRINOLOGY_PROCEDURES,
  isDMInEndocrinologyDept,
} from "../../../constants/endocrinologyProcedures";
import {
  MEDICAL_GENETICS_CATEGORIES,
  MEDICAL_GENETICS_PROCEDURES,
  isDMInMedicalGeneticsDept,
} from "../../../constants/medicalGeneticsProcedures";
import {
  GERIATRIC_MENTAL_HEALTH_CATEGORIES,
  GERIATRIC_MENTAL_HEALTH_PROCEDURES,
  isDMInGeriatricMentalHealthDept,
} from "../../../constants/geriatricMentalHealthProcedures";
import {
  PEDIATRIC_NEPHROLOGY_CATEGORIES,
  PEDIATRIC_NEPHROLOGY_PROCEDURES,
  isDMInPediatricNephrologyDept,
} from "../../../constants/pediatricNephrologyProcedures";
import {
  NEONATOLOGY_CATEGORIES,
  NEONATOLOGY_PROCEDURES,
  isDMInNeonatologyDept,
} from "../../../constants/neonatologyProcedures";
import {
  CLINICAL_PHARMACOLOGY_CATEGORIES,
  CLINICAL_PHARMACOLOGY_PROCEDURES,
  isDMInClinicalPharmacologyDept,
} from "../../../constants/clinicalPharmacologyProcedures";
import {
  NEUROLOGY_CATEGORIES,
  NEUROLOGY_PROCEDURES,
  isDMInNeurologyDept,
} from "../../../constants/neurologyProcedures";
import {
  GYNAECOLOGICAL_ONCOLOGY_CATEGORIES,
  GYNAECOLOGICAL_ONCOLOGY_PROCEDURES,
  isMChInGynaecologicalOncologyDept,
} from "../../../constants/gynaecologicalOncologyProcedures";
import {
  HAND_SURGERY_CATEGORIES,
  HAND_SURGERY_PROCEDURES,
  isMChInHandSurgeryDept,
} from "../../../constants/handSurgeryProcedures";
import {
  HPB_SURGERY_CATEGORIES,
  HPB_SURGERY_PROCEDURES,
  isMChInHPBSurgeryDept,
} from "../../../constants/hpbSurgeryProcedures";
import {
  REPRODUCTIVE_MEDICINE_CATEGORIES,
  REPRODUCTIVE_MEDICINE_PROCEDURES,
  isMChInReproductiveMedicineDept,
} from "../../../constants/reproductiveMedicineProcedures";
import {
  VASCULAR_SURGERY_CATEGORIES,
  VASCULAR_SURGERY_PROCEDURES,
  isMChInVascularSurgeryDept,
} from "../../../constants/vascularSurgeryProcedures";
import {
  SURGICAL_GASTROENTEROLOGY_CATEGORIES,
  SURGICAL_GASTROENTEROLOGY_PROCEDURES,
  isMChInSurgicalGastroenterologyDept,
} from "../../../constants/surgicalGastroenterologyProcedures";
import {
  PEDIATRIC_SURGERY_CATEGORIES,
  PEDIATRIC_SURGERY_PROCEDURES,
  isMChInPediatricSurgeryDept,
} from "../../../constants/pediatricSurgeryProcedures";
import {
  PLASTIC_SURGERY_CATEGORIES,
  PLASTIC_SURGERY_PROCEDURES,
  isMChInPlasticSurgeryDept,
} from "../../../constants/plasticSurgeryProcedures";
import {
  ENDOCRINE_SURGERY_CATEGORIES,
  ENDOCRINE_SURGERY_PROCEDURES,
  isMChInEndocrineSurgeryDept,
} from "../../../constants/endocrineSurgeryProcedures";
import {
  UROLOGY_CATEGORIES,
  UROLOGY_PROCEDURES,
  isMChInUrologyDept,
} from "../../../constants/urologyProcedures";

/**
 * Professional form inputs for activity details
 */
const ActivityFormInputs = ({ formData, updateField, errors = {}, userDepartment, activityCountsByDate = {} }) => {
  const isAnaesthesiaStudent = isDiplomaInAnaesthesiaDept(userDepartment);
  const isPathologyStudent = isDiplomaInClinicalPathologyDept(userDepartment);
  const isDVLStudent = isDiplomaInDVLDept(userDepartment);
  const isENTStudent = isDiplomaInENTDept(userDepartment);
  const isImmunohaematologyStudent = isDiplomaInImmunohaematologyDept(userDepartment);
  const isOBGYStudent = isDiplomaInOBGYDept(userDepartment);
  const isOphthalmologyStudent = isDiplomaInOphthalmologyDept(userDepartment);
  const isOrthopaedicsStudent = isDiplomaInOrthopaedicsDept(userDepartment);
  const isPaediatricsStudent = isDiplomaInPaediatricsDept(userDepartment);
  const isPsychiatryStudent = isDiplomaInPsychiatryDept(userDepartment);
  const isPMRStudent = isDiplomaInPMRDept(userDepartment);
  const isPulmonaryStudent = isDiplomaInPulmonaryDept(userDepartment);
  const isRadioDiagnosisStudent = isDiplomaInRadioDiagnosisDept(userDepartment);
  const isRadiationMedicineStudent = isDiplomaInRadiationMedicineDept(userDepartment);
  const isTropicalMedicineStudent = isDiplomaInTropicalMedicineDept(userDepartment);
  const isAllergyImmunologyStudent = isDiplomaInAllergyImmunologyDept(userDepartment);
  const isAerospaceStudent = isMDInAerospaceDept(userDepartment);
  const isAnatomyStudent = isMDInAnatomyDept(userDepartment);
  const isBiochemistryStudent = isMDInBiochemistryDept(userDepartment);
  const isCommunityMedicineStudent = isMDInCommunityMedicineDept(userDepartment);
  const isDVLMDStudent = isMDInDVLDept(userDepartment);
  const isFamilyMedicineStudent = isMDInFamilyMedicineDept(userDepartment);
  const isForensicMedicineStudent = isMDInForensicMedicineDept(userDepartment);
  const isGeneralMedicineStudent = isMDInGeneralMedicineDept(userDepartment);
  const isGeneralSurgeryStudent = isMSInGeneralSurgeryDept(userDepartment);
  const isTraumatologyStudent = isMSInTraumatologyDept(userDepartment);
  const isClinicalImmunologyStudent = isDMInClinicalImmunologyDept(userDepartment);
  const isHepatologyStudent = isDMInHepatologyDept(userDepartment);
  const isCriticalCareStudent = isDMInCriticalCareDept(userDepartment);
  const isNeuroanaesthesiaStudent = isDMInNeuroanaesthesiaDept(userDepartment);
  const isNeuroradiologyStudent = isDMInNeuroradiologyDept(userDepartment);
  const isOrganTransplantAnaesthesiaStudent = isDMInOrganTransplantAnaesthesiaDept(userDepartment);
  const isPediatricOncologyStudent = isDMInPediatricOncologyDept(userDepartment);
  const isPediatricHepatologyStudent = isDMInPediatricHepatologyDept(userDepartment);
  const isPaediatricNeurologyStudent = isDMInPaediatricNeurologyDept(userDepartment);
  const isVirologyStudent = isDMInVirologyDept(userDepartment);
  const isInfectiousDiseasesStudent = isDMInInfectiousDiseasesDept(userDepartment);
  const isEndocrinologyStudent = isDMInEndocrinologyDept(userDepartment);
  const isMedicalGeneticsStudent = isDMInMedicalGeneticsDept(userDepartment);
  const isGeriatricMentalHealthStudent = isDMInGeriatricMentalHealthDept(userDepartment);
  const isPediatricNephrologyStudent = isDMInPediatricNephrologyDept(userDepartment);
  const isNeonatologyStudent = isDMInNeonatologyDept(userDepartment);
  const isClinicalPharmacologyStudent = isDMInClinicalPharmacologyDept(userDepartment);
  const isNeurologyStudent = isDMInNeurologyDept(userDepartment);
  const isGynaecologicalOncologyStudent = isMChInGynaecologicalOncologyDept(userDepartment);
  const isHandSurgeryStudent = isMChInHandSurgeryDept(userDepartment);
  const isHPBSurgeryStudent = isMChInHPBSurgeryDept(userDepartment);
  const isReproductiveMedicineStudent = isMChInReproductiveMedicineDept(userDepartment);
  const isVascularSurgeryStudent = isMChInVascularSurgeryDept(userDepartment);
  const isSurgicalGastroenterologyStudent = isMChInSurgicalGastroenterologyDept(userDepartment);
  const isPediatricSurgeryStudent = isMChInPediatricSurgeryDept(userDepartment);
  const isPlasticSurgeryStudent = isMChInPlasticSurgeryDept(userDepartment);
  const isEndocrineSurgeryStudent = isMChInEndocrineSurgeryDept(userDepartment);
  const isUrologyStudent = isMChInUrologyDept(userDepartment);
  const isGeriatricsStudent = isMDInGeriatricsDept(userDepartment);
  const isHealthAdminStudent = isMDInHealthAdminDept(userDepartment);
  const isImmunohematologyMDStudent = isMDInImmunohematologyDept(userDepartment);
  const isMicrobiologyStudent = isMDInMicrobiologyDept(userDepartment);
  const isNuclearMedicineMDStudent = isMDInNuclearMedicineDept(userDepartment);
  const isPathologyMDStudent = isMDInPathologyDept(userDepartment);
  const isPharmacologyStudent = isMDInPharmacologyDept(userDepartment);
  const isPhysiologyStudent = isMDInPhysiologyDept(userDepartment);
  const isRadiotherapyMDStudent = isMDInRadiotherapyDept(userDepartment);
  const isSportsMedicineStudent = isMDInSportsMedicineDept(userDepartment);
  const isPalliativeMedicineStudent = isMDInPalliativeMedicineDept(userDepartment);
  const isMarineMedicineStudent = isMDInMarineMedicineDept(userDepartment);
  const isLaboratoryMedicineStudent = isMDInLaboratoryMedicineDept(userDepartment);
  const isEmergencyMedicineStudent = isMDInEmergencyMedicineDept(userDepartment);
  const isProcedureSelected =
    formData.type === "Procedure" || formData.type === "Procedures";

  const availableAnaesthesiaProcedures = formData.procedureCategory
    ? DIPLOMA_ANAESTHESIA_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePathologyProcedures = formData.procedureCategory
    ? CLINICAL_PATHOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableDVLProcedures = formData.procedureCategory
    ? DVL_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableENTProcedures = formData.procedureCategory
    ? ENT_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableImmunohaematologyProcedures = formData.procedureCategory
    ? IMMUNOHAEMATOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableOBGYProcedures = formData.procedureCategory
    ? OBGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableOphthalmologyProcedures = formData.procedureCategory
    ? OPHTHALMOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableOrthopaedicsProcedures = formData.procedureCategory
    ? ORTHOPAEDICS_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePaediatricsProcedures = formData.procedureCategory
    ? PAEDIATRICS_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePsychiatryProcedures = formData.procedureCategory
    ? PSYCHIATRY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePMRProcedures = formData.procedureCategory
    ? PMR_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePulmonaryProcedures = formData.procedureCategory
    ? PULMONARY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableRadioDiagnosisProcedures = formData.procedureCategory
    ? RADIODIAGNOSIS_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableRadiationMedicineProcedures = formData.procedureCategory
    ? RADIATION_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableTropicalMedicineProcedures = formData.procedureCategory
    ? TROPICAL_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableAllergyImmunologyProcedures = formData.procedureCategory
    ? ALLERGY_IMMUNOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableAerospaceProcedures = formData.procedureCategory
    ? AEROSPACE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableAnatomyProcedures = formData.procedureCategory
    ? ANATOMY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableBiochemistryProcedures = formData.procedureCategory
    ? BIOCHEMISTRY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableCommunityMedicineProcedures = formData.procedureCategory
    ? COMMUNITY_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableDVLMDProcedures = formData.procedureCategory
    ? DVL_MD_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableFamilyMedicineProcedures = formData.procedureCategory
    ? FAMILY_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableForensicMedicineProcedures = formData.procedureCategory
    ? FORENSIC_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableGeneralMedicineProcedures = formData.procedureCategory
    ? GENERAL_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableGeriatricsProcedures = formData.procedureCategory
    ? GERIATRICS_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableHealthAdminProcedures = formData.procedureCategory
    ? HEALTH_ADMIN_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableImmunohematologyMDProcedures = formData.procedureCategory
    ? IMMUNOHEMATOLOGY_MD_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableMicrobiologyProcedures = formData.procedureCategory
    ? MICROBIOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableNuclearMedicineMDProcedures = formData.procedureCategory
    ? NUCLEAR_MEDICINE_MD_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePathologyMDProcedures = formData.procedureCategory
    ? PATHOLOGY_MD_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePharmacologyProcedures = formData.procedureCategory
    ? PHARMACOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePhysiologyProcedures = formData.procedureCategory
    ? PHYSIOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableRadiotherapyMDProcedures = formData.procedureCategory
    ? RADIOTHERAPY_MD_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableSportsMedicineProcedures = formData.procedureCategory
    ? SPORTS_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePalliativeMedicineProcedures = formData.procedureCategory
    ? PALLIATIVE_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableMarineMedicineProcedures = formData.procedureCategory
    ? MARINE_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableLaboratoryMedicineProcedures = formData.procedureCategory
    ? LABORATORY_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableEmergencyMedicineProcedures = formData.procedureCategory
    ? EMERGENCY_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableGeneralSurgeryProcedures = formData.procedureCategory
    ? GENERAL_SURGERY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableTraumatologyProcedures = formData.procedureCategory
    ? TRAUMATOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableClinicalImmunologyProcedures = formData.procedureCategory
    ? CLINICAL_IMMUNOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableHepatologyProcedures = formData.procedureCategory
    ? HEPATOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableCriticalCareProcedures = formData.procedureCategory
    ? CRITICAL_CARE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableNeuroanaesthesiaProcedures = formData.procedureCategory
    ? NEUROANAESTHESIA_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableNeuroradiologyProcedures = formData.procedureCategory
    ? NEURORADIOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableOrganTransplantAnaesthesiaProcedures = formData.procedureCategory
    ? ORGAN_TRANSPLANT_ANAESTHESIA_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePediatricOncologyProcedures = formData.procedureCategory
    ? PEDIATRIC_ONCOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePediatricHepatologyProcedures = formData.procedureCategory
    ? PEDIATRIC_HEPATOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePaediatricNeurologyProcedures = formData.procedureCategory
    ? PAEDIATRIC_NEUROLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableVirologyProcedures = formData.procedureCategory
    ? VIROLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableInfectiousDiseasesProcedures = formData.procedureCategory
    ? INFECTIOUS_DISEASES_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableEndocrinologyProcedures = formData.procedureCategory
    ? ENDOCRINOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableMedicalGeneticsProcedures = formData.procedureCategory
    ? MEDICAL_GENETICS_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableGeriatricMentalHealthProcedures = formData.procedureCategory
    ? GERIATRIC_MENTAL_HEALTH_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePediatricNephrologyProcedures = formData.procedureCategory
    ? PEDIATRIC_NEPHROLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableNeonatologyProcedures = formData.procedureCategory
    ? NEONATOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableClinicalPharmacologyProcedures = formData.procedureCategory
    ? CLINICAL_PHARMACOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableNeurologyProcedures = formData.procedureCategory
    ? NEUROLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableGynaecologicalOncologyProcedures = formData.procedureCategory
    ? GYNAECOLOGICAL_ONCOLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableHandSurgeryProcedures = formData.procedureCategory
    ? HAND_SURGERY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableHPBSurgeryProcedures = formData.procedureCategory
    ? HPB_SURGERY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableReproductiveMedicineProcedures = formData.procedureCategory
    ? REPRODUCTIVE_MEDICINE_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableVascularSurgeryProcedures = formData.procedureCategory
    ? VASCULAR_SURGERY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableSurgicalGastroenterologyProcedures = formData.procedureCategory
    ? SURGICAL_GASTROENTEROLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePediatricSurgeryProcedures = formData.procedureCategory
    ? PEDIATRIC_SURGERY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availablePlasticSurgeryProcedures = formData.procedureCategory
    ? PLASTIC_SURGERY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableEndocrineSurgeryProcedures = formData.procedureCategory
    ? ENDOCRINE_SURGERY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const availableUrologyProcedures = formData.procedureCategory
    ? UROLOGY_PROCEDURES[formData.procedureCategory] || []
    : [];

  const handleCategoryChange = (category) => {
    updateField("procedureCategory", category);
    updateField("procedureSubtype", ""); // Reset procedure when category changes
  };

  const activityTypes = [
    "Academics",
    "Awards/Honours/Achievements",
    "Case Discussions",
    "CME/Conference/Workshops",
    "Details of Postings",
    "District Residency Program",
    "In Patients",
    "Internal Assessment",
    "Journal Clubs",
    "Laboratory",
    "Leave",
    "Out Patients",
    "Outreach",
    "Paper/Poster Presentation",
    "PG Discussions",
    "Presentation",
    "Procedures",
    "Publication Details",
    "Recognitions",
    "Research",
    "Seminar",
    "Students Symposium",
    "Surgery Assisted",
    "Surgery Done",
    "Surgeries Observed",
    "Teaching",
    "Thesis",
    "Thesis Evaluation",
    "UG Classes Teaching",
  ];

  // ✅ Parse stored "YYYY-MM-DD" string as LOCAL date (no UTC shift)
  const parseLocalDate = (dateStr) => {
    if (!dateStr) return null;
    const [y, m, d] = dateStr.split("-").map(Number);
    return new Date(y, m - 1, d);
  };

  // ✅ Format picker Date object to "YYYY-MM-DD" using LOCAL time (no UTC shift)
  const formatLocalDate = (date) => {
    if (!date) return "";
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const isMBBSStudent = useMemo(() => {
    try {
      const raw = localStorage.getItem("user") || localStorage.getItem("userData") || "{}";
      const u = JSON.parse(raw);
      const p = u.profile || u;

      const course = String(p.course || u.course || p.course_display || u.course_display || "")
        .trim()
        .toUpperCase();

      return course === "MBBS";
    } catch (e) {
      return false;
    }
  }, []);

  return (
    <div className="space-y-6">
      {/* MBBS Competencies Field (Exclusive to MBBS Students - Placed FIRST) */}
      {isMBBSStudent && (
        <div>
          <CompetencySearchSelect
            competencies={formData.competencies || []}
            onChange={(val) => updateField("competencies", val)}
          />
        </div>
      )}
      {/* Title */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Activity Title <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={formData.title}
          onChange={(e) => updateField("title", e.target.value)}
          className={`
            w-full px-4 py-2.5 text-sm
            bg-white border rounded-lg
            transition-colors duration-200
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
            ${errors.title ? "border-red-300 focus:ring-red-500" : "border-gray-300"}
          `}
          placeholder="Enter activity title"
        />
        {errors.title && (
          <p className="mt-1.5 text-sm text-red-600">{errors.title}</p>
        )}
      </div>

      {/* Date and Type Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Date */}
        <DatePickerInput
          label="Activity Date"
          required
          selected={parseLocalDate(formData.date)}
          onChange={(date) => updateField("date", formatLocalDate(date))}
          placeholder="Select date"
          maxDate={new Date()}
          error={errors.date}
          activityCountsByDate={activityCountsByDate}
        />

        


        {/* Activity Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Activity Type <span className="text-red-500">*</span>
          </label>
          <select
            value={formData.type}
            onChange={(e) => updateField("type", e.target.value)}
            className={`
              w-full px-4 py-2.5 text-sm
              bg-white border rounded-lg
              transition-colors duration-200
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
              ${errors.type ? "border-red-300 focus:ring-red-500" : "border-gray-300"}
            `}
          >
            <option value="">Select Activity Type</option>
            {activityTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
          {errors.type && (
            <p className="mt-1.5 text-sm text-red-600">{errors.type}</p>
          )}
        </div>

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in Anaesthesia */}
        {isAnaesthesiaStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={DIPLOMA_ANAESTHESIA_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableAnaesthesiaProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Clinical Pathology */}
        {isPathologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={CLINICAL_PATHOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePathologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in DVL */}
        {isDVLStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={DVL_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableDVLProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in ENT */}
        {isENTStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={ENT_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableENTProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in Immunohaematology */}
        {isImmunohaematologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={IMMUNOHAEMATOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableImmunohaematologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in OBGY */}
        {isOBGYStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={OBGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableOBGYProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in Ophthalmology */}
        {isOphthalmologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={OPHTHALMOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableOphthalmologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in Orthopaedics */}
        {isOrthopaedicsStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={ORTHOPAEDICS_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableOrthopaedicsProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in Paediatrics */}
        {isPaediatricsStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PAEDIATRICS_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePaediatricsProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in Psychiatry */}
        {isPsychiatryStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PSYCHIATRY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePsychiatryProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in PMR */}
        {isPMRStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PMR_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePMRProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in Pulmonary Medicine */}
        {isPulmonaryStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PULMONARY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePulmonaryProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in Radio-diagnosis */}
        {isRadioDiagnosisStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={RADIODIAGNOSIS_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableRadioDiagnosisProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in Radiation Medicine */}
        {isRadiationMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={RADIATION_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableRadiationMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in Tropical Medicine */}
        {isTropicalMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={TROPICAL_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableTropicalMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for Diploma in Allergy & Clinical Immunology */}
        {isAllergyImmunologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={ALLERGY_IMMUNOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableAllergyImmunologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Aerospace Medicine */}
        {isAerospaceStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={AEROSPACE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableAerospaceProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Human Anatomy */}
        {isAnatomyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={ANATOMY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableAnatomyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Biochemistry */}
        {isBiochemistryStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={BIOCHEMISTRY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableBiochemistryProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Community Medicine */}
        {isCommunityMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={COMMUNITY_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableCommunityMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in DVL */}
        {isDVLMDStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={DVL_MD_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableDVLMDProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Family Medicine */}
        {isFamilyMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={FAMILY_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableFamilyMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Forensic Medicine */}
        {isForensicMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={FORENSIC_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableForensicMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in General Medicine */}
        {isGeneralMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={GENERAL_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableGeneralMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Geriatrics */}
        {isGeriatricsStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={GERIATRICS_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableGeriatricsProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Health Administration */}
        {isHealthAdminStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={HEALTH_ADMIN_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableHealthAdminProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Immunohematology & Blood Transfusion */}
        {isImmunohematologyMDStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={IMMUNOHEMATOLOGY_MD_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableImmunohematologyMDProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Microbiology */}
        {isMicrobiologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={MICROBIOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableMicrobiologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Nuclear Medicine */}
        {isNuclearMedicineMDStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={NUCLEAR_MEDICINE_MD_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableNuclearMedicineMDProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Pathology */}
        {isPathologyMDStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PATHOLOGY_MD_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePathologyMDProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Pharmacology */}
        {isPharmacologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PHARMACOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePharmacologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Physiology */}
        {isPhysiologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PHYSIOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePhysiologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Radiotherapy */}
        {isRadiotherapyMDStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={RADIOTHERAPY_MD_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableRadiotherapyMDProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Sports Medicine */}
        {isSportsMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={SPORTS_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableSportsMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Palliative Medicine */}
        {isPalliativeMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PALLIATIVE_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePalliativeMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Marine Medicine */}
        {isMarineMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={MARINE_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableMarineMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Laboratory Medicine */}
        {isLaboratoryMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={LABORATORY_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableLaboratoryMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MD in Emergency Medicine */}
        {isEmergencyMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={EMERGENCY_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableEmergencyMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MS in General Surgery */}
        {isGeneralSurgeryStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={GENERAL_SURGERY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableGeneralSurgeryProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for MS in Traumatology & Surgery */}
        {isTraumatologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={TRAUMATOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableTraumatologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Clinical Immunology & Rheumatology */}
        {isClinicalImmunologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={CLINICAL_IMMUNOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableClinicalImmunologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Hepatology */}
        {isHepatologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={HEPATOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableHepatologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Critical Care Medicine */}
        {isCriticalCareStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={CRITICAL_CARE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableCriticalCareProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Neuroanaesthesia */}
        {isNeuroanaesthesiaStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={NEUROANAESTHESIA_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableNeuroanaesthesiaProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Neuroradiology */}
        {isNeuroradiologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={NEURORADIOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableNeuroradiologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Organ Transplant Anaesthesia */}
        {isOrganTransplantAnaesthesiaStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={ORGAN_TRANSPLANT_ANAESTHESIA_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableOrganTransplantAnaesthesiaProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Pediatric Oncology */}
        {isPediatricOncologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PEDIATRIC_ONCOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePediatricOncologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Pediatric Hepatology */}
        {isPediatricHepatologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PEDIATRIC_HEPATOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePediatricHepatologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Paediatric Neurology */}
        {isPaediatricNeurologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PAEDIATRIC_NEUROLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePaediatricNeurologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Virology */}
        {isVirologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={VIROLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableVirologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Infectious Diseases */}
        {isInfectiousDiseasesStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={INFECTIOUS_DISEASES_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableInfectiousDiseasesProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Endocrinology */}
        {isEndocrinologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={ENDOCRINOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableEndocrinologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Medical Genetics */}
        {isMedicalGeneticsStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={MEDICAL_GENETICS_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableMedicalGeneticsProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Geriatric Mental Health */}
        {isGeriatricMentalHealthStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={GERIATRIC_MENTAL_HEALTH_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableGeriatricMentalHealthProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Pediatric Nephrology */}
        {isPediatricNephrologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PEDIATRIC_NEPHROLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePediatricNephrologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Neonatology */}
        {isNeonatologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={NEONATOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableNeonatologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Clinical Pharmacology */}
        {isClinicalPharmacologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={CLINICAL_PHARMACOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableClinicalPharmacologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for DM in Neurology */}
        {isNeurologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={NEUROLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableNeurologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for M.Ch. in Gynaecological Oncology */}
        {isGynaecologicalOncologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={GYNAECOLOGICAL_ONCOLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableGynaecologicalOncologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for M.Ch. in Hand Surgery */}
        {isHandSurgeryStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={HAND_SURGERY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableHandSurgeryProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for M.Ch. in HPB Surgery */}
        {isHPBSurgeryStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={HPB_SURGERY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableHPBSurgeryProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for M.Ch. in Reproductive Medicine and Surgery */}
        {isReproductiveMedicineStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={REPRODUCTIVE_MEDICINE_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableReproductiveMedicineProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for M.Ch. in Vascular Surgery */}
        {isVascularSurgeryStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={VASCULAR_SURGERY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableVascularSurgeryProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for M.Ch. in Surgical Gastroenterology */}
        {isSurgicalGastroenterologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={SURGICAL_GASTROENTEROLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableSurgicalGastroenterologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for M.Ch. in Pediatric Surgery */}
        {isPediatricSurgeryStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PEDIATRIC_SURGERY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePediatricSurgeryProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for M.Ch. in Plastic Surgery */}
        {isPlasticSurgeryStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={PLASTIC_SURGERY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availablePlasticSurgeryProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for M.Ch. in Endocrine Surgery */}
        {isEndocrineSurgeryStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={ENDOCRINE_SURGERY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableEndocrineSurgeryProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}

        {/* Mandatory Procedure Category & Procedure Searchable Dropdowns for M.Ch. in Urology */}
        {isUrologyStudent && isProcedureSelected && (
          <>
            <div className="md:col-span-2">
              <SearchableSelect
                label="Procedure Category"
                required
                options={UROLOGY_CATEGORIES}
                value={formData.procedureCategory || ""}
                onChange={handleCategoryChange}
                placeholder="Select Procedure Category"
                searchPlaceholder="Search category..."
                error={errors.procedureCategory}
              />
            </div>

            {formData.procedureCategory && (
              <div className="md:col-span-2 animate-in fade-in duration-200">
                <SearchableSelect
                  label="Procedure"
                  required
                  options={availableUrologyProcedures}
                  value={formData.procedureSubtype || ""}
                  onChange={(val) => updateField("procedureSubtype", val)}
                  placeholder={`Select Procedure under ${formData.procedureCategory}`}
                  searchPlaceholder="Search procedure..."
                  error={errors.procedureSubtype}
                />
              </div>
            )}
          </>
        )}
      </div>

      {/* Competency Address and Attempt Type Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Attempt Type  */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Attempt Type
          </label>
          <select
            value={formData.attemptType}
            onChange={(e) => updateField("attemptType", e.target.value)}
            className="
              w-full px-4 py-2.5 text-sm
              bg-white border border-gray-300 rounded-lg
              transition-colors duration-200
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
            "
          >
            <option value="">Select Attempt Type</option>
            <option value="First(F)">First (F)</option>
            <option value="Repeat(R)">Repeat (R)</option>
            <option value="Remedial(Re)">Remedial (Re)</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default ActivityFormInputs;

//8
